<template>
<div id="cartaporte">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="mdi-cash" title="Generar CFDI de Pago" class="elevation-1 px-5 py-3">
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="purple" small @click="nuevo" title="Nuevo Pago" style="color:white;" v-tippy>
                            <v-icon small>mdi-file</v-icon>Nuevo Pago
                        </v-btn>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()">
                            <v-client-table ref="vuetable" :data="items.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="json.Total" slot-scope="props">
                                    <div v-if="props.row.json.TipoDeComprobante !='P'" class="text-right">
                                        {{props.row.json.Total}}
                                    </div>
                                    <div v-if="props.row.json.TipoDeComprobante =='P'" class="text-right">
                                        {{props.row.json.Complemento.Pagos.Totales.MontoTotalPagos}}
                                    </div>
                                </template>

                                <template slot="json.Fecha" slot-scope="props">
                                    <div>
                                        {{props.row.json.Fecha.substring(0, 10).replace("T", " ").substring(0, 16)}}
                                    </div>
                                </template>

                                <template slot="add" slot-scope="props">
                                    <div style="width: 20px !important;">
                                        <v-btn v-if=" permiso_pagos && props.row.estatus ==1 && props.row.json.TipoDeComprobante=='I'" color="green" fab x-small dark title="AGREGAR A PAGO MULTIPLE" @click="cargaPagos(props.row, 2)">
                                            <v-icon small>mdi-arrow-left-bold</v-icon>
                                        </v-btn>
                                    </div>
                                </template>

                                <template slot="actions" slot-scope="props">
                                    <div style="width: 20px !important;">
                                        <v-btn v-if=" permiso_pagos && props.row.estatus ==1 && props.row.json.TipoDeComprobante=='I'" color="purple" fab x-small dark title="CREAR PAGO INDIVIDUAL" @click="cargaPagos(props.row, 1)">
                                            <v-icon small>mdi-cash</v-icon>
                                        </v-btn>

                                    </div>
                                </template>
                            </v-client-table>
                            <template>
                                <div v-if="pwPagination.total > 0">
                                    <div class="mt-3">
                                        <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="items" :options="pwPagination.options"></PaginacionComponent>
                                    </div>
                                </div>
                            </template>
                        </div>

                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>

    </v-container>

</div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import PaginacionComponent from '@/components/PaginacionComponent.vue';

export default {
    components: {
        "PaginacionComponent": PaginacionComponent
    },
    name: "DashboardDataTables",
    mounted: function () {

        this.model_filters = this.$refs.vuetable.query;

    },
    watch: {
        model_filters: {
            handler(val) {
                let filtros = {
                    "estatus": 1,
                    "json.MetodoPago": "PPD"
                };

                if (this.model_filters["json.Receptor.Nombre"]) {
                    filtros["json.Receptor.Nombre"] = { '$regex': this.model_filters["json.Receptor.Nombre"], '$options': 'i' };
                }
                if (this.model_filters["json.Receptor.Rfc"]) {
                    filtros["json.Receptor.Rfc"] = { '$regex': this.model_filters["json.Receptor.Rfc"], '$options': 'i' };
                }
                if (this.model_filters["json.Fecha"]) {
                    filtros["json.Fecha"] = { '$regex': this.model_filters["json.Fecha"], '$options': 'i' };
                }
                if (this.model_filters['json.Complemento.TimbreFiscalDigital.UUID']) {
                    filtros["json.Complemento.TimbreFiscalDigital.UUID"] = { '$regex': this.model_filters['json.Complemento.TimbreFiscalDigital.UUID'], '$options': 'i' };
                }
                if (this.model_filters['json.Folio']) {
                    filtros["json.Folio"] = this.model_filters['json.Folio'];
                }
                if (this.model_filters['json.Serie']) {
                    filtros["json.Serie"] = { '$regex': this.model_filters['json.Serie'], '$options': 'i' };
                }
                if (this.model_filters['json.Total']) {
                    filtros["json.Total"] = this.model_filters['json.Total'];
                }

                this.pwPagination.options.filters = {
                    filtros: filtros,
                    cliente: this.emisor
                }
            },
            deep: true
        }
    },
    data: () => ({
        tabla: "carta_porte",
        id_solicitud_correo: "",
        check_cliente: 0,
        check_receptor: 0,
        correo_receptor: "",
        correo_cliente: [],
        modalCorreo: false,
        correo: {
            correos: "",
            responder_a: "contacto@power-devel.com",
            asunto: "Factura Carta Porte",
            mensaje: "Se adjunta PDF y XML de su factura."
        },
        url: 'https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/',
        // url: 'http://localhost:8000/',
        URL_SAT: "",
        s_origen: false,
        emisor: "",
        model_filters: "",
        pwPagination: {
            total: 0,
            links: {
                url: '',
                next: '',
                prev: '',
            },
            options: {
                tipo: 1,
                size: 10,
                filters: {}
            }
        },
        id_solicitud: "",
        id_solicitud_cancelado: "",
        motivo: "",
        modal_cancelar: false,
        s_destino: false,
        hora_salida: "",
        hora_llegada: "",
        origen: {},
        destino: {},
        origenes: [],
        destinos: [],
        receptores: [],
        receptor: {},
        id_empresa: "",
        id_licencia: "",
        modal: false,
        usuario: "",
        clientes: [],
        por_pagar: [],
        menu1: false,
        compartir_clientes: "",
        indexSeleccionado: "x",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "CFDI de Pago",
                disabled: true,
                href: "",
            },
        ],
        estatus: [{
            "estatus": "Activo"
        }, {
            "estatus": "Inactivo"
        }],
        model: {
            id_solicitud: "",
            uuid_empresa: "",
            uuid_licencia: "",
            cliente: "",
            error_pdf: "",
            error_solicitud: "",
            estatus: "",
            fecha_creado: "",
            fecha_timbrado: "",
            json: {},
            key_pdf: "",
        },
        emptymodel: {
            id_solicitud: "",
            uuid_empresa: "",
            uuid_licencia: "",
            cliente: "",
            error_pdf: "",
            error_solicitud: "",
            estatus: "",
            fecha_creado: "",
            fecha_timbrado: "",
            json: {},
            key_pdf: "",
        },
        updateModel: false,
        rules: {},
        motivos: [{
                clave: "01",
                nombre: "Comprobantes emitidos con errores con relación"
            },
            {
                clave: "02",
                nombre: "Comprobantes emitidos con errores sin relación"
            },
            {
                clave: "03",
                nombre: "No se llevó a cabo la operación"
            },
            {
                clave: "04",
                nombre: "Operación nominativa relacionada en una factura globa"
            }
        ],
        columns: ["add", "json.Serie", "json.Folio", "json.Fecha", "json.Complemento.TimbreFiscalDigital.UUID", "json.Receptor.Rfc", "json.Receptor.Nombre", "json.Total", "actions"],
        options: {
            filterable: ["json.Serie", "json.Folio", "json.Fecha", "json.Complemento.TimbreFiscalDigital.UUID", "json.Receptor.Rfc", "json.Receptor.Nombre", "json.Total", ],
            sortable: ["json.Serie", "json.Folio", "json.Fecha", "json.Complemento.TimbreFiscalDigital.UUID", "json.Receptor.Rfc", "json.Receptor.Nombre", "json.Total", ],
            filterByColumn: true,
            listColumns: {
                estatus: [{
                        "id": 0,
                        "text": "CREADO"
                    },
                    {
                        "id": 1,
                        "text": "TIMBRADO"
                    },
                    {
                        "id": 2,
                        "text": "ERROR"
                    },
                    {
                        "id": 3,
                        "text": "CANCELADO"
                    },
                    {
                        "id": 4,
                        "text": "ERROR PAQ"
                    },
                    {
                        "id": 5,
                        "text": "ERROR PAQ DE TIMBRADO"
                    }
                ]
            },

            headings: {
                add: "",
                "json.Complemento.TimbreFiscalDigital.UUID": "UUID",
                "json.Receptor.Rfc": "RFC",
                "json.Receptor.Nombre": "Destino",
                "json.Fecha": "Fecha Timbrado",
                "json.Serie": "Serie",
                "json.Folio": "Folio",
                "json.Total": "Total",

                actions: ""
            },
            customFilters: [{
                name: 'estatus',
                callback: function (row, query) {
                    return row.estatus == query;
                }
            }]

        },
        export_excel: {
            "Solicitud": "id_solicitud",
            "UUID": "json.Complemento.TimbreFiscalDigital.UUID",
            "Tipo": "json.TipoDeComprobante",
            "Fecha Creación": "fecha_creado",
            "RFC": "json.Receptor.Rfc",
            "Destino": "json.Receptor.Nombre",
            "Fecha Timbrado": "json.Fecha",
            "Serie": "json.Serie",
            "Folio": "json.Folio",
            "Total": "json.Total",
            "Error": "error_solicitud",
            "Estatus": "estatus"
        },
        items: {
            items: []
        },
        search: undefined,
    }),
    computed: {
        tituloModal() {
            return this.updateModel === false ? "Nueva Carta Porte" : "Editar Carta Porte";
        },
        permiso_editar() {
            return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.nueva'))) == '1';
        },
        permiso_pagos() {
            return this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256('factura.pagos'))) == '1';
        },
        datafiltered() {

            let result = [];
            if (this.$refs.vuetable != null) {
                result = this.$refs.vuetable.allFilteredData;
                return result;
            } else {
                result = this.items;
                return result;
            }
        },
    },
    methods: {

        nuevo() {

            this.$local_storage.set('UUID', "");
            this.$local_storage.set('RFC_RECEPTOR', "");
            this.$local_storage.set('TOTAL', "");
            this.$router.replace("/newpago");
        },

        openmodalcancelar: function (id) {
            this.id_solicitud_cancelado = id;
            this.modal_cancelar = true;
        },
        getIndex: function (item) {
            const search = (element) => element.folio == item.folio && element.uuid_licencia == item.uuid_licencia;
            var idx = this.items.items.findIndex(search);
            return idx;
        },
        getEstatus(index) {
            let estatus = ["ENVIADO", "TIMBRADO", "ERROR", "CANCELADO", "ERROR PAQ", "ERROR PAQ DE TIMBRADO"];
            return estatus[index];
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },

        cargar: function () {
            var self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");

            self.id_solicitud = self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("id_solicitud")));

            var params = {
                "cliente": self.emisor,
                "filtros": {
                    "estatus": 1,
                    "json.MetodoPago": "PPD",
                    "json.TipoDeComprobante": "I"
                }
            }

            this.$axios.post(this.url + "carta_porte/list_carta_porte/", params)
                .then(res => {
                    self.items.items = res.data.results;
                    /*   if(res.data.results.length > 0)
                       self.items.items = res.data.results.filter((x) => x.estatus == 1 && x.json.TipoDeComprobante == "I");
                     else
                       self.items.items = [];  */

                    // if (self.items.items.length > 0)
                    // self.items.items.forEach(function(i) {
                    //   i.estatus = self.getEstatus(i.estatus);
                    //   i.fecha_creado = i.fecha_creado.replace("T", " ").substring(0, 16);
                    //   i.json.Fecha = i.json.Fecha.substring(0, 10);
                    //
                    // })
                    self.pwPagination.total = res.data.count;
                    self.pwPagination.links.next = res.data.next;
                    self.pwPagination.links.prev = res.data.previous;
                    self.$root.$dialogLoader.hide();
                })
                .catch(err => {
                    self.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: "",
                    });
                    console.log(err);
                }).then(() => {
                    self.$root.$dialogLoader.hide();
                });
        },

        getPDF: function (id) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;
            var data = {
                id_solicitud: id,
            };
            axios.post(this.url + 'carta_porte/get_url_pdf_mongo/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        axios({
                                method: 'get',
                                url: res.data,
                                responseType: 'arraybuffer'
                            })
                            .then(response => {

                                this.forceFileDownload(response, id + ".pdf")
                                self.$root.$dialogLoader.hide();
                            })
                            .catch(() => console.log('error occured'))
                        self.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    self.$root.$dialogLoader.hide();
                });
        },
        getXML: function (id, file) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;

            var data = {
                key: file.replace('pdf', 'xml'),
            };
            axios.post(this.url + 'carta_porte/get_download_url_mongo/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        axios({
                                method: 'get',
                                url: res.data,
                                responseType: 'arraybuffer'
                            })
                            .then(response => {

                                this.forceFileDownload(response, id + ".xml")
                                self.$root.$dialogLoader.hide();
                            })
                            .catch(() => console.log('error occured'))
                        self.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    self.$root.$dialogLoader.hide();
                });
        },
        getAcuseXML: function (id, file) {
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var self = this;
            let f = file.replace('pdf', 'xml');
            f = f.replace(id, 'cancelado_' + id);
            var data = {
                key: f,
            };

            axios.post(this.url + 'carta_porte/get_download_url_mongo/', data)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        axios({
                                method: 'get',
                                url: res.data,
                                responseType: 'arraybuffer'
                            })
                            .then(response => {

                                this.forceFileDownload(response, "Acuse_" + id + ".xml")
                                self.$root.$dialogLoader.hide();
                            })
                            .catch(() => console.log('error occured'))
                        self.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    self.$root.$dialogLoader.hide();
                });
        },
        forceFileDownload(response, name) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', name) //or any other extension
            document.body.appendChild(link)
            link.click()
        },
        cargarEmisor: async function () {
            let self = this;
            this.$root.$dialogLoader.show("Espere un momento por favor..");
            var params = {
                "filtros": {
                    "uuid": self.id_empresa
                }
            };

            await this.$axios.post(this.url + "carta_porte/administracion/list_empresas/", params)
                .then(res => {
                    if (res.data.length > 0) {
                        self.emisor = res.data[0].rfc;
                        self.cargar();
                    } else {
                        self.$swal({
                            type: "error",
                            title: "Error",
                            text: "No se encontro la empresa.",
                            footer: "",
                        });
                    }
                })
                .catch(err => {
                    self.$swal({
                        type: "error",
                        title: "Error",
                        text: "Ocurrió un error al obtener los registros.",
                        footer: "",
                    });
                    console.log(err);
                }).then(() => {
                    self.$root.$dialogLoader.hide();
                });
        },
        cargaPagos(row, tipo) {
            var self = this;
            self.$root.$dialogLoader.show("Espere un momento por favor..");
            let uuid = row.json.Complemento.TimbreFiscalDigital.UUID;
            var params = {
                "id_solicitud": row.id_solicitud
            }
            self.$axios.post(self.url + "carta_porte/get_pagos/", params)
                .then(async res => {

                    var pagados = [];
                    var result = res.data;
                    var pagado = 0;
                    var continuar = true;
                    var renglones = "";
                    result.forEach(function (r) {
                        var pagos = r.pagos.Pago[0].DoctoRelacionado;

                        pagos.forEach(function (p) {
                            if (p.IdDocumento == uuid) {
                                pagados.push({
                                    "ImpPagado": p.ImpPagado,
                                    "Serie": r.serie,
                                    "Folio": r.folio,
                                    "UUID": r.uuid
                                });
                                renglones += '<tr><td>' + r.serie +'</td> <td> ' + r.folio+' </td><td> ' + r.uuid+' </td><td class="text-right"> '+ p.ImpPagado +'</td> </tr>'
                            }

                        })
                    });

                    if (pagados.length > 0) {
                        continuar = false;

                      var tabla = '<table class="table table-striped table-bordered table-condensed">' +
                                        '<thead> <tr><th>Serie</th> <th>Folio</th> <th>UUID</th> <th class="text-right">Total</th></tr> </thead>' +
                                        '<tbody>' +
                                          renglones +
                                        '</tbody>' +
                                    '</table>';

                        var string = JSON.stringify(pagados);
                      await  self.$swal({
                            type: "info",
                            title: "Cuidado",
                            text: "¿La Factura ya cuenta con pagos registrados desea continuar?",
                            footer: tabla,
                            showCancelButton: true,
                            cancelButtonColor: "#d33",
                            confirmButtonColor: "#3085d6",
                            confirmButtonText: "Continuar",
                            cancelButtonText: "Cancelar"
                        }).then(result => {

                            if (result.value) {
                                continuar = true;

                            }
                        });
                    }
                    self.$local_storage.set('RFC_RECEPTOR', row.json.Receptor.Rfc);
                    self.$local_storage.set('RECEPTOR',  JSON.stringify(row.json.Receptor));
                    if (tipo == 1 && continuar) {
                        self.$local_storage.set('UUID', uuid);

                        self.$local_storage.set('TOTAL', row.json.Total);
                        self.$local_storage.set('IMPUESTOS', JSON.stringify(row.json.Impuestos));
                        self.$router.replace("/newpago");
                    }
                    if (tipo == 2 && continuar) {

                        if(self.$local_storage.get('pagos') == undefined || self.$local_storage.get('pagos') == null)
                          self.por_pagar = [];
                        else
                          self.por_pagar = JSON.parse(self.$local_storage.get('pagos'));

                        let x = self.por_pagar.filter((x) => x.UUID == uuid);
                        if (x.length > 0) {
                            self.$swal({
                                type: "error",
                                title: "Imposible Agregar",
                                text: "Esa Factura ya esta en la lista.",
                                footer: "",
                            });
                        } else {
                            if (self.por_pagar.length == 0 || row.json.Receptor.Rfc == self.por_pagar[0].RFC_RECEPTOR) {
                                self.por_pagar.push({
                                    'UUID': uuid,
                                    'RFC_RECEPTOR': row.json.Receptor.Rfc,
                                    'TOTAL': row.json.Total,
                                    'SERIE': row.json.Serie,
                                    'FOLIO': row.json.Folio,
                                    'IMPUESTOS': row.json.Impuestos,
                                    'SUBTOTAL': row.json.SubTotal,

                                })

                                self.$local_storage.set('pagos', JSON.stringify(self.por_pagar));
                                self.$store.state.pagos = self.por_pagar.length;
                            } else {
                                self.$swal({
                                    type: "error",
                                    title: "Imposible Agregar",
                                    text: "Esa Factura no pertenece al mismo RFC: " + self.por_pagar[0].RFC_RECEPTOR + " de la lista. ",
                                    footer: "",
                                });
                            }
                        }
                    }

                    self.$root.$dialogLoader.hide();
                })
                .catch(err => {
                    console.log(err);
                }).then(() => {
                    self.$root.$dialogLoader.hide();
                });

        }
    },
    created: async function () {
        this.$root.$dialogLoader.show("Espere un momento por favor..");
        this.rules = this.$rules;
        this.usuario = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("nombre_usuario")));
        this.id_empresa = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")));
        this.id_licencia = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_licencia")));
        this.compartir_clientes = this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("compartir_clientes")));
        this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";
        if (this.id_empresa != null && this.id_empresa != "") {

            var saldo = await this.$funciones.get_saldo(this.id_empresa);
            this.$local_storage.set("saldo", saldo);
            this.$store.state.instancia += saldo;
        } else {
            this.$local_storage.set("saldo", 0);
            this.$store.state.instancia += 0;
        }

        await this.cargarEmisor();

        this.pwPagination.links.url = this.url + "carta_porte/list_carta_porte/";
        this.pwPagination.options.filters.cliente = this.emisor;
    },
};
</script>

<style scoped>
.VueTables>>>thead th {
    white-space: normal !important;
}

.VueTables>>>tbody td {
    white-space: normal !important;
}

.footer-hide>>>.VuePagination {
    display: none;
}

.VuePagination__count {
    display: none !important;
}
</style>
